// according to Cashpresso, minimum rate is 3 Euro
// standard minimum is about 3% of the financing price
// if it's not 100% accurate, it's still fine as per our discussions
export const MINIMUM_RATE = 3;

export const getMinimumRate = (financingPrice?: number | null): number => {
  const price = Math.round((financingPrice && financingPrice * 0.03) || 0);
  return price > MINIMUM_RATE ? price : MINIMUM_RATE;
};
